import React from 'react';
import PropTypes from 'prop-types';
import Select, {selectType} from 'Components/Select';
import { ACTION } from 'constants/index';
import moment from 'moment';

export default class Row extends React.Component {
  _selectAction = actionKey => {
    const { family, performActionFunction, updateFamiliesListEntry } = this.props;
    performActionFunction(actionKey, family.id).then(updatedData => updateFamiliesListEntry(family, updatedData));
  };

  _getStatusColor = () => {
    const { family } = this.props;

    if (family && family.status) {
      return `list-scene__status-label_${family.status.toString().toLowerCase()}`;
    }
    return '';
  };

  _getTextColourStyle = key => {
    const { sortedBy } = this.props;

    if (sortedBy === key) return 'active';
    return '';
  };

  _getFamilyReadableStatus = () => {
    const { family } = this.props;

    if (family && family.status) {
      return (family.status[0].toUpperCase() + family.status.slice(1).toLowerCase()).replace('_', ' ');
    }

    return '';
  };

  _getBackgroundColourStyle = () => {
    const { isOdd } = this.props;

    return isOdd ? '_background_color_pale_gray' : '_background_color_white';
  };

  render() {
    const { family, availableActionsList } = this.props;

    return (
      <div
        id={`familyListRowId${family.id}`}
        className={`list-scene__table-row ${this._getBackgroundColourStyle()}`}
        onClick={() => {
          this._selectAction(ACTION.DETAILS);
        }}
      >
        <div className={`list-scene__status-bar_left ${this._getStatusColor()}`} />

        <div
          id='componentSubmissionDateField'
          className={`list-scene__table-row-element list-scene__table-row-element_text-element
        ${this._getTextColourStyle('submissionDate')} _width_pc_8`}
        >
          {moment(family.submissionDate).format('MM/DD/YYYY')}
        </div>

        <div
          id='familyTypeField'
          className={`list-scene__table-row-element list-scene__table-row-element_text-element
        ${this._getTextColourStyle('componentType')} _width_pc_20`}
        >
          {family.type.componentTypeName}
        </div>

        <div
          id='familyNameField'
          className={`list-scene__table-row-element list-scene__table-row-element_text-element
        ${this._getTextColourStyle('name')} list-scene__table-row-element_place_filler`}
        >
          {family.name}
        </div>

        <div className='list-scene__table-row-element list-scene__table-row-element_item-element _width_pc_15'>
          <div
            id='familyStatusField'
            className={`list-scene__status-label ${this._getStatusColor()} ${this._getTextColourStyle('status')}`}
          >
            {this._getFamilyReadableStatus()}
          </div>
        </div>

        <div className='list-scene__table-row-element list-scene__table-row-element_item-element _width_pc_12'>
          <Select
            placeholder='Actions'
            withoutSearch
            multiSelect
            selectionList={availableActionsList}
            handleSelect={this._selectAction}
            type={selectType.listActions}
          />
        </div>

        <div className={`list-scene__status-bar_right ${this._getStatusColor()}`} />
      </div>
    );
  }
}

Row.propTypes = {
  family: PropTypes.object.isRequired,
  isOdd: PropTypes.bool.isRequired,
  zIndex: PropTypes.number
};



// WEBPACK FOOTER //
// ./src/app/Scenes/ComponentManufacturer/FamilyList/Row.jsx